import api from '../config/api';

const configuracionViaticosStandardService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-viaticos-standard/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de viáticos standard',
      };
    }
  },

  /**
   * @param {number|string} empresaId
   * @param {boolean|object} payload - boolean legacy (solo activo) u objeto { activo, plame_configuracion_id, tipo_boleta_destino }
   */
  async actualizarConfiguracion(empresaId, payload) {
    try {
      const body = typeof payload === 'object' && payload !== null
        ? {
            activo: Boolean(payload.activo),
            plame_configuracion_id: payload.plame_configuracion_id ?? null,
            numero_recibo_activo: payload.numero_recibo_activo != null
              ? Boolean(payload.numero_recibo_activo)
              : undefined,
            tipo_boleta_destino: payload.tipo_boleta_destino || undefined,
          }
        : { activo: Boolean(payload) };

      // Quitar undefined para no pisar campos no enviados
      Object.keys(body).forEach((k) => {
        if (body[k] === undefined) delete body[k];
      });

      const response = await api.put(`/configuracion-viaticos-standard/empresa/${empresaId}`, body);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de viáticos standard',
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-viaticos-standard/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de viáticos standard',
      };
    }
  },
};

export default configuracionViaticosStandardService;

/**
 * Expande destino de config a lista de tipo_boleta para payload de tareo.
 * @param {'plame'|'interna'|'ambas'|string} destino
 * @param {'plame'|'interna'|'ambas'|string} [defaultDestino='plame'] - si destino viene vacío
 * @returns {string[]}
 */
export function expandirDestinosBoleta(destino, defaultDestino = 'plame', tipoPlanilla = null) {
  const raw = String(destino || '').toLowerCase().trim();
  const d = raw || String(defaultDestino || 'plame').toLowerCase().trim();
  const tipo = String(tipoPlanilla || '').toLowerCase();
  const tieneInterna = tipo === 'dual' || tipo === 'solo_interna';
  if (d === 'ambas' || d === 'ambos' || d === 'plame+interna') {
    // Trabajador solo PLAME: no crear fila interna para no duplicar en esa boleta
    if (tipoPlanilla != null && tipoPlanilla !== '' && !tieneInterna) return ['plame'];
    return ['plame', 'interna'];
  }
  if (d === 'interna' || d === 'interno') return ['interna'];
  return ['plame'];
}
